import React from 'react';
import { contactInfo } from '../data/mock';

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white py-8">
      <div className="container mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 mb-6">
          <div>
            <h3 className="text-xl font-bold mb-3">{contactInfo.brandName}</h3>
            <p className="text-gray-400">{contactInfo.domain}</p>
            <p className="text-sm text-gray-400 mt-3 italic">
              SOS Casa Roma: professionisti certificati al servizio dei romani dal 2021
            </p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-3">Contatti</h4>
            <p className="text-gray-400">Tel/WhatsApp: {contactInfo.phone}</p>
            <p className="text-gray-400 mt-1">{contactInfo.location}</p>
          </div>
          
          <div>
            <h4 className="font-semibold mb-3">Orari</h4>
            <p className="text-gray-400">Disponibili H24, 7 giorni su 7,</p>
            <p className="text-gray-400">inclusi festivi</p>
          </div>
        </div>
        
        <div className="border-t border-gray-800 pt-6 text-center">
          <p className="text-gray-400 text-sm mb-2">
            SOS Casa Roma: professionisti certificati al servizio dei romani dal 2021
          </p>
          <p className="text-gray-400 text-sm">
            &copy; {new Date().getFullYear()} {contactInfo.brandName}. Tutti i diritti riservati.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
